import { ReactElement, useEffect, useState } from "react";
import { IDashboardComponent, IIndicatorConfig, IIndicators } from "../../../types";
import { getPaletteColor } from "../../../../../configuration/configuration";
import { IRealtimeData } from "../../../../../types";
import { Sparklines, SparklinesLine } from "react-sparklines";
import { getConditionResult, getStatusClass } from "../../../utils";
import { getFloatValue } from "../../../../../system/utils";

interface IProps {
  // parentSize: IParentSize;
  realtime: Record<string, IRealtimeData>;
  component: IDashboardComponent<IIndicatorConfig>;
}

const sparklineLimit = 60;

const IndicatorComponent = ({ component, realtime }: IProps): ReactElement | null => {
  const [ indicators, setIndicators ] = useState<Record<string, IIndicators>>({});
  const indicator = indicators[component.config.variables[0].hash];

  useEffect(() => {
    const newRecord = { ...indicators };
    component.config.variables.forEach(v => {
      const value = getFloatValue(realtime[v.code], 0);
      const condition = getConditionResult(value, v.conditions ?? [], realtime);
      const status = condition && condition.severity !== "none" ? condition.severity : null;

      if (!newRecord[v.hash]) {
        newRecord[v.hash] = {
          ...v,
          value,
          status,
          lastPoints:  [value]
        };
      } else {
        newRecord[v.hash].title = v.title;
        newRecord[v.hash].color = v.color;
        newRecord[v.hash].unit = v.unit;
        newRecord[v.hash].hideChart = v.hideChart;
        newRecord[v.hash].value = realtime[v.code] ? realtime[v.code].Value : "---";
        newRecord[v.hash].status = status;
        newRecord[v.hash].lastPoints.push(value);
      }

      while (newRecord[v.hash].lastPoints.length > sparklineLimit) {
        newRecord[v.hash].lastPoints.shift();
      }
    });

    setIndicators(newRecord);
  }, [component, realtime]);

  const hasUnit = indicator && indicator.unit && indicator.unit !== "";
  const errorClass = getStatusClass(indicator?.status);
  const valueColor = errorClass === "" ? indicator?.color ?? getPaletteColor() : "whitesmoke";

  return indicator ?
    <div className={`display-grid align-items-stretch h-100 ${errorClass}`} style={{ gridTemplateRows: indicator.hideChart ? "auto 1fr" : "auto auto 1fr" }}>
      <strong style={{ textAlign: "center", color: component.foreground }}>
        {indicator.title}
        {hasUnit && <small style={{ fontSize: "0.5em" }}>{` [${indicator.unit}]`}</small>}
      </strong>
      <strong style={{ color: valueColor, fontSize: indicator.hideChart ? "3em" : "2em", textAlign: "center" }} >
        { typeof indicator.value === "number" ? indicator.value.toFixed(indicator.decimals) : indicator.value }
      </strong>
      {!indicator.hideChart &&
        <Sparklines data={indicator.lastPoints} limit={sparklineLimit} style={{ width: "100%" }}>
          <SparklinesLine color={valueColor}/>
        </Sparklines>
      }
      {/*{ Object.values(indicators).map((indicator, index) => {*/}
      {/*  return (*/}
      {/*    <div key={`ind-${component.key}-${index}`} className="display-flex-column m-1  card-bordered-rounded justify-content-center p-1"*/}
      {/*      style={{ minWidth: 200,  background: "#424242", borderRadius: "4px" }}  >*/}
      {/*      <strong style={{ textAlign: "center" }}>{indicator.title}</strong>*/}
      {/*      <strong style={{ color: indicator.color ?? getPaletteColor(), fontSize: "2em", textAlign: "center" }} >{indicator.value}</strong>*/}
      {/*      <Sparklines data={indicator.lastPoints} limit={30} width={200} height={50} >*/}
      {/*        <SparklinesLine color={indicator.color ?? getPaletteColor()}/>*/}
      {/*      </Sparklines>*/}
      {/*    </div>*/}
      {/*  );*/}
      {/*})}*/}
    </div>
    : null;
};

export default IndicatorComponent;
